module.exports = __webpack_public_path__ + "img/user--activity 1.6b5f713f.svg";